<template>
    <main id="service-sheet-comparator">
        <div class="content-available-soon">
            {{ $t('content_available_soon') }}
        </div>
    </main>
</template>

<script>
    export default {
        name: 'ServiceComparisonView',
        components: {}
    }
</script>


<style lang="scss">
    #service-sheet-comparator {
        padding-top: 35px;
        padding-bottom: 40px;
    }
</style>
